import React, { Component } from 'react';

import { TableLayout } from '../Menu/Stock/containers/Layout';

import SearchBar from './Layouts/SeachBar';
import Dialog from '../../commonModules/interface/Dialog';

import NewFormRegestering from '../Menu/module/NewFormRegestering';
import Form from 'react-jsonschema-form';
import { isEmpty } from "lodash";
import { Button, Grid, Box, Table, TableHead, TableRow, TableCell, TableBody, Fab } from '@material-ui/core';
import { AccountCircleRounded, BuildRounded, FileCopyRounded, ListAltRounded, BuildOutlined, AddRounded } from '@material-ui/icons';
import { blue, cyan, green, pink } from '@material-ui/core/colors';
import CardButton from '../../commonModules/interface/CardButton';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab';
import PageAdmin from './Layouts/PageAdmin';
import SearchBarAction from './Layouts/SearchBarAction';
import { toast } from 'react-toastify';

class SchemasList extends Component {
    state = { 
        new: false,
        newReport: false,
        newQuotation: false,
        newSav: false,
        preview: false,
        typeSchema: "",
        newComplementary: false,
        list: [],
        mdpAdmin:'',
        errors:{
            mdpAdmin:'',
        },
        dialogDelete: false,
        delete: {},
        
        form:{
            uiSchema:{},
            jsonSchema:{},
        },
        schemaID:"",
        nameSchema:"",
     }
    componentDidMount = async () => {
        const { SCHEMAS } = this.props;
        if( !SCHEMAS){
            await Promise.all([
                this.props.fetchSchemas(),
                this.props.fetchReportSchemas(),
                this.props.fetchQuotationSchemas(),
                this.props.fetchSavSchemas(),
            ])
        }
        this.filterList()
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.SCHEMAS) ){
                list = Object.keys(this.props.SCHEMAS)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    handleConnexionTechnicalSAV= async (e) => {
        e.preventDefault();
        //Send disactivation to back
        try {
            const infos = await fetch('/schema/define?idSchema='+this.state.schemaID+'&type=SAV',{
                method:'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            let body = await infos.json();

            if(body.error=== "OK"){
                toast.success("Formulaire Défini comme SAV",)
                this.setState({preview:false})
            } else {
                toast.error( "Action Impossible")
            }
        } catch (e) {
            console.log(e);
            toast.error( "Internal Error")
        }  
    }
    
    handleDisactivation = async (e) => {
        e.preventDefault();
        //Send disactivation to back
        try {
            const infos = await fetch('/schema/disactivate?idSchema='+this.state.schemaID,{
                method:'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            let body = await infos.json();

            if(body.error=== "OK"){
                toast.success("Formulaire désactivé")
                this.setState({preview:false})
                //Mise à jour des schémas
                this.props.fetchSchemas();
                this.props.fetchReportSchemas();
                this.props.fetchQuotationSchemas();
                this.props.fetchSavSchemas();
            } else {
                toast.error( "Action Impossible")
            }
        } catch (e) {
            console.log(e);
            toast.error( "Internal Error")
        }  
    }
    
    handleChange = (e) =>{
        const field = e.target.name
        const value = e.target.value
        this.setState({
            [field]: value
        })
    }
    getSchema = async (idSchema, typeSchema, nameSchema) => {// request to get Schema info
        console.log("DISPLAY SCHEMA START", typeSchema);
        try {
            const infos = await fetch('/schema/get?idSchema='+idSchema,{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            let body = await infos.json();

            if(body.error){
                console.log("[ERROR] error get Schemas", body);  
                return false
            } else {
                console.log('====================================');
                console.log({body});
                console.log('====================================');
                this.setState({
                    form:{
                        uiSchema:JSON.parse(body.uiSchema),
                        jsonSchema:JSON.parse(body.jsonSchema),
                    },
                    schemaID:body.schemaID,
                    nameSchema,
                    typeSchema: typeSchema,
                    preview: true
                })
                return true
            }
        } catch (e) {
            console.log(e);
            return false
        }  
    }

    render() {
        const { SCHEMAS } = this.props;
        console.log('====================================');
        console.log("[STATE] schemas list", this.state);
        console.log('====================================');
        let actions = [
            {
                openAction:() => this.setState({ new: true }),
                icon:<AccountCircleRounded color="primary"/>,
                title: "Agents"
            },
            {
                openAction: () =>this.setState({ newReport: true }),
                icon: <BuildRounded color="secondary" />,
                title: "Pannes"
            },
            {
                openAction: () =>this.setState({ newQuotation: true }),
                icon: <FileCopyRounded style={{ color: blue[200] }} />,
                title: "Visites"
            },
            {
                openAction: () =>this.setState({ newSav: true }),
                icon: <BuildOutlined style={{ color: pink[200]}}  />,
                title: "SAV"
            },
            {
                openAction: () =>this.setState({ newComplementary: true }),
                icon: <ListAltRounded style={{ color: green[200] }} />,
                title: "Complementary"
            }
        ]
        
        return (
            <PageAdmin title="Schémas">
                
                {this.state.new &&
                    <NewFormRegestering 
                        popupState={"overlay"} 
                        onCloseOverlay={()=>
                            this.setState({ new: false })
                        }
                    />
                }
                {this.state.newReport && 
                    <NewFormRegestering 
                        popupState={"overlay"} 
                        onCloseOverlay={()=>
                            this.setState({ newReport: false })
                        } 
                        report={true}
                    />
                }
                {this.state.newQuotation && 
                    <NewFormRegestering 
                        popupState={"overlay"} 
                        onCloseOverlay={()=>
                            this.setState({ newQuotation: false })
                        } 
                        quotation={true}
                    />
                }
                {this.state.newSav && 
                    <NewFormRegestering 
                        popupState={"overlay"} 
                        onCloseOverlay={()=>
                            this.setState({ newSav: false })
                        } 
                        sav={true}
                    />
                }
                {this.state.newComplementary && 
                    <NewFormRegestering 
                        popupState={"overlay"} 
                        onCloseOverlay={()=>
                            this.setState({ newComplementary: false })
                        } 
                        complementary={true}
                    />
                }
                
                
                {(this.state.preview && this.state.schemaID) &&
                    <Dialog
                        block={this.state.preview}
                        close={()=>
                            this.setState({ 
                                preview: false, 
                                schemaID: "", 
                                nameSchema: "", 
                                form:{
                                    uiSchema:{},
                                    jsonSchema:{},
                                }, 
                            })
                        }
                        title={this.state.nameSchema}
                        submitAction={ this.state.typeSchema === "SAV" ? this.handleConnexionTechnicalSAV : this.handleDisactivation}
                        submitTitle={ this.state.typeSchema === "SAV" ? "Définir formulaire SAV Technique" : "Désactiver ce formulaire"}
                    >
                        <Form
                            schema={this.state.form.jsonSchema}
                            uiSchema={this.state.form.uiSchema}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled
                                >
                                    Valider
                                </Button>
                        </Form>
                        {/* { this.state.typeSchema === "SAV" ?
                            <Button type="button" variant="contained" color="primary" onClick={this.handleConnexionTechnicalSAV}>Définir formulaire SAV Technique</Button>
                        :
                            <Button type="button" variant="contained" color="secondary" onClick={this.handleDisactivation}>Désactiver ce formulaire</Button>
                        } */}
                    </Dialog>
                }
                {this.state.openFormTypes &&
                    <Dialog
                        title="Nouveau formulaire"
                        block={true}
                        close={() => this.setState({ 
                            openFormTypes: false,
                            new: false ,
                            newReport: false ,
                            newQuotation: false ,
                            newSav: false ,
                            newComplementary: false
                        }) }
                    >
                        {actions.map(action =>
                            <CardButton
                                action={action.openAction}
                                icon={action.icon}
                                title={action.title}
                            />
                        )}
                    </Dialog>
                }
                
                <SearchBarAction list={ SCHEMAS } filterList={this.filterList} action={ () => this.setState({ openFormTypes: true}) }/>
                
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {SCHEMAS && this.state.list.map( ID => {
                            let schema = SCHEMAS[ID]
                            return(
                                <TableRow key={ID} onClick={() => this.getSchema(ID, schema.type, schema.name) } >
                                    <TableCell>{schema.name}</TableCell>
                                    <TableCell>{ schema.type }</TableCell>
                                   
                                    {/* <TableCell>{!subscribed_list.includes(ID) &&
                                            <button className="btn btn-danger" onClick={
                                                ()=>this.setState({delete:schema,  dialogDelete: true})
                                            } >Supprimer</button>
                                        }
                                    </TableCell> */}
                                </TableRow>
                            )
                        } )
                    }
                    </TableBody>
                </TableLayout>
            </PageAdmin>
        );
    }
}


export default SchemasList